import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sortBy: 'priceAsc',
  selectedFacilities: [],
  selectedStarRatings: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
};

export const FilterHotelSlice = createSlice({
  name: 'filter-hotels',
  initialState,
  reducers: {
    sortByLowestPriceHotels(state, action) {
      state.sortBy = action.payload;
    },
    setSelectedFacilities(state, action) {
      state.selectedFacilities = action.payload;
    },
    setSelectedStarRatings(state, action) {
      state.selectedStarRatings = action.payload;
    },
    clearSetSelectedFacilities(state, action) {
      state.selectedFacilities = [];
    }, 
    clearSetSelectedStarRatings(state, action) {
      state.selectedStarRatings = { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    },
  },
});

export const {
  sortByLowestPriceHotels,
  setSelectedFacilities,
  setSelectedStarRatings,
  clearSetSelectedStarRatings,
  clearSetSelectedFacilities
} = FilterHotelSlice.actions;

export default FilterHotelSlice.reducer;
